import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { NotaFiscalContext } from 'app/main/nota-fiscal/NotaFiscalContext';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext } from 'react';
import { NotaFiscalModais } from '../NotaFiscalModais';
import NotaFiscalBuscaAvancadaForm from './NotaFiscalBuscaAvancadaForm';

const NotaFiscalBuscaAvancadaModal = ({ fetchNotasFiscais }) => {
  const [modal, setModal] = useContext(NotaFiscalContext).modal;
  const [filtroAvancado, setFiltroAvancado] = useContext(NotaFiscalContext).filtroAvancado;
  const [search] = useContext(NotaFiscalContext).search;
  const [sort] = useContext(NotaFiscalContext).sort;
  const [size] = useContext(NotaFiscalContext).size;
  const [data] = useContext(NotaFiscalContext).data;

  const handleSubmit = (values) => {
    setFiltroAvancado(values);
    fetchNotasFiscais({
      q: search?.q,
      mesCompetencia: search?.mesCompetencia || data,
      filtroAvancado: values,
      size,
      sort,
    });
    setModal('');
  };

  const handleCancelar = () => {
    const close = () => {
      formik.resetForm(formik.initialValues);
      setModal('');
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const formik = useFormik({
    initialValues: {
      tipo: filtroAvancado.tipo,
      servico: filtroAvancado.servico,
      produto: filtroAvancado.produto,
      situacao: filtroAvancado.situacao,
      serieNF: filtroAvancado.serieNF || undefined,
      emCancelamento: filtroAvancado.emCancelamento,
      erroCancelamento: filtroAvancado.erroCancelamento,
    },
    onSubmit: handleSubmit,
  });

  return (
    <SimpleDialog open={modal === NotaFiscalModais.buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<NotaFiscalBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default NotaFiscalBuscaAvancadaModal;
